// NEW_FILE_JUSTIFIED: New component in voiceAgents feature directory; StatCard import is a reused component, not a duplicate
import { StatCard } from '@/components/dashboard/StatCard';
import type { IVoiceDashboardStats } from '@/@types/voiceAgents';

interface IVoiceDashboardStatsProps {
  // LOCAL_TYPE_JUSTIFIED: single-use props interface for this leaf component
  stats: IVoiceDashboardStats | undefined;
}

function formatDuration(ms: number): string {
  const seconds = Math.round(ms / 1000);
  const minutes = Math.floor(seconds / 60);
  const remaining = seconds % 60;
  return `${minutes}:${String(remaining).padStart(2, '0')}`;
}

function formatCost(cents: number): string {
  return `$${(cents / 100).toFixed(2)}`;
}

export function VoiceDashboardStats({ stats }: IVoiceDashboardStatsProps) {
  const sentimentLabel = stats
    ? `+${stats.sentimentBreakdown.positive} / ~${stats.sentimentBreakdown.neutral} / -${stats.sentimentBreakdown.negative}`
    : undefined;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
      <StatCard label="Total Calls" value={stats?.totalCalls} subtitle="last 7 days" />
      <StatCard
        label="Avg Duration"
        value={stats ? Math.round(stats.avgDurationMs / 1000) : undefined}
        subtitle={stats ? formatDuration(stats.avgDurationMs) : undefined}
      />
      <StatCard
        label="Sentiment"
        value={stats ? stats.sentimentBreakdown.positive : undefined}
        subtitle={sentimentLabel}
      />
      <StatCard
        label="Avg TTFA"
        value={stats ? Math.round(stats.avgTimeToFirstAudioMs) : undefined}
        subtitle={stats ? `${Math.round(stats.avgTimeToFirstAudioMs)}ms` : undefined}
      />
      <StatCard
        label="Total Cost"
        value={stats ? Math.round(stats.totalCost) : undefined}
        subtitle={stats ? formatCost(stats.totalCost) : undefined}
      />
    </div>
  );
}
